import { TYPE_STRING } from './input-types';

export const id = 'notesFromBuyer';
export const apiKey = 'NotesFromBuyer';
export const type = TYPE_STRING;

export const notesFromBuyer = {
  id,
  apiKey,
  type,
};
